{
	"imprintTitle": "Impressum",
	"termsAndConditionsTitle": "Warunki korzystania",
	"privacyPolicyTitle": "Polityka prywatności",
	"openSourceAttributionTitle": "Atrybucja open source"
}
